import {
  Elevation,
  Card,
  Container,
  CaptionText,
  Link,
  Button,
  EditIcon,
  Row,
  Col,
} from '@paypalcorp/pp-react'
import React, { useEffect } from 'react'
import Share from './components/Share'
import * as styles from './otherScreensGroupDetail.css'
import * as commonStyles from './index.css'
import { GROUP_STATUS } from '../../constants'
import { GroupStatusType } from '../../../typings'
import { Message } from '@paypalcorp/worldready-react'

interface OtherScreensGroupDetailProps {
  HeaderGroup: React.ReactNode
  StripComponent: React.ReactNode
  ActivityComponent: React.ReactNode
  FlatProgressComponent: React.ReactNode
  shareLink: string
  reportLink: string
  groupName: string
  groupStatus: GroupStatusType
  isEditEnabled: boolean
  hasBackgroundImage: boolean
  handleClickOnEdit: () => void
  isAdmin: boolean
  handleClickOnReport: () => void
  isPayPalUser: boolean
  groupId: string
}

const OtherScreensGroupDetail = (props: OtherScreensGroupDetailProps) => {
  const {
    HeaderGroup,
    StripComponent,
    ActivityComponent,
    FlatProgressComponent,
    shareLink,
    reportLink,
    groupName,
    groupStatus,
    isEditEnabled,
    hasBackgroundImage,
    handleClickOnEdit,
    isAdmin,
    handleClickOnReport,
    isPayPalUser,
    groupId,
  } = props

  useEffect(() => {
    setTimeout(() => {
      // give browser a moment to add the element to the DOM
      // without setTimeout, scrollTo doesn't scroll all the way to the top, which is weird
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    }, 100)
  }, [])

  const editButton = (
    <div className={styles.editButtonContainer}>
      <Button
        data-testid="editButton"
        variant="tertiary"
        iconComponent={EditIcon}
        onClick={handleClickOnEdit}
        className={styles.editButton}
      >
        <Message id="detail.edit" />
      </Button>
    </div>
  )

  const reportPool = (
    <div className={styles.btnCenterStyles}>
      <CaptionText type="strong" className={styles.reportGroupActStyles}>
        <Link
          href={reportLink}
          target="_blank"
          onClick={handleClickOnReport}
          data-testid="reportButton"
        >
          <Message id="detail.reportGroup" />
        </Link>
      </CaptionText>
    </div>
  )

  const isActive = groupStatus === GROUP_STATUS.ACTIVE

  return (
    <div className={commonStyles.containerSmallerDivStyles}>
      <div
        className={styles.overlayDetailContainer}
        data-testid="otherScreensContainer"
      >
        <div className={styles.imgFullBackground}>
          <div className={commonStyles.imageDivStyles}>{StripComponent}</div>
        </div>
        <div
          className={
            hasBackgroundImage
              ? commonStyles.detailContainer
              : commonStyles.closedDetailContainer
          }
        >
          <Elevation level={2} className={commonStyles.elevationStyles}>
            <Card className={commonStyles.cardStyles}>
              {isEditEnabled && editButton}
              <div
                className={
                  isEditEnabled
                    ? styles.ownerDetailContainer
                    : styles.detailContainerPadding
                }
              >
                <Container>
                  <Row>
                    <Col xs={12}>{HeaderGroup}</Col>
                  </Row>
                  <Row>
                    <Col xs={12}>{FlatProgressComponent}</Col>
                  </Row>
                  {isActive && (
                    <Row>
                      <Col>
                        <Share
                          shareLink={shareLink}
                          groupName={groupName}
                          isAdmin={isAdmin}
                          isPayPalUser={isPayPalUser}
                          groupId={groupId}
                        />
                      </Col>
                    </Row>
                  )}
                  <Row>
                    <Col xs={12}>{ActivityComponent}</Col>
                  </Row>
                </Container>
              </div>
            </Card>
          </Elevation>
          {!isAdmin && reportPool}
        </div>
      </div>
    </div>
  )
}

export default OtherScreensGroupDetail
